<template>
  <div class="page-list">
    <CCard>
      <CCardHeader class="d-flex justify-content-between align-items-center">
        <strong>صفحات</strong>
        <CButton color="primary" size="sm" @click="$router.push('/dashboard/pages/add')"><CIcon name="cil-plus" size="sm"/> صفحه جدید</CButton>
      </CCardHeader>
      <CCardBody>
        <ServerTable ref="table" url="/api/admin/page/get_pages" :fields="fields" search-placeholder="عنوان یا نامک" empty-text="صفحه‌ای یافت نشد">
          <template #name="{item}"><td><a href="#" @click.prevent="edit(item)"><strong>{{ item.name }}</strong></a></td></template>
          <template #slug="{item}"><td dir="ltr" class="text-right small text-muted">/page/{{ item.slug }}</td></template>
          <template #status="{item}"><td><span :class="['badge', item.status === 1 ? 'badge-success' : 'badge-secondary']">{{ item.status === 1 ? 'منتشر شده' : 'پیش‌نویس' }}</span></td></template>
          <template #updated_at="{item}"><td class="text-muted small">{{ get_date_time(item.updated_at) }}</td></template>
          <template #operation="{item}">
            <td class="text-nowrap">
              <CButton color="primary" variant="outline" square size="sm" title="ویرایش" @click="edit(item)"><CIcon name="cil-pencil" size="sm"/></CButton>
              <CButton color="info" variant="outline" square size="sm" title="مشاهده" @click="view(item)"><CIcon name="cil-external-link" size="sm"/></CButton>
              <CButton color="danger" variant="outline" square size="sm" title="حذف" @click="remove(item)"><CIcon name="cil-trash" size="sm"/></CButton>
            </td>
          </template>
        </ServerTable>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import axios from "@/api/http";
import ServerTable from "@/views/includes/ServerTable.vue";
import { confirmAsk, apiToast } from "@/utils/confirm";

export default {
  name: 'PageList',
  components: { ServerTable },
  data() {
    return {
      fields: [
        { key: 'name', label: 'عنوان' },
        { key: 'slug', label: 'آدرس' },
        { key: 'status', label: 'وضعیت' },
        { key: 'updated_at', label: 'آخرین ویرایش' },
        { key: 'operation', label: 'عملیات' },
      ],
    }
  },
  methods: {
    edit(item) { this.$router.push('/dashboard/pages/edit/' + item.id) },
    view(item) { window.open(String(localStorage.getItem('web_address') || '').replace(/\/+$/, '') + '/page/' + item.slug, '_blank') },
    async remove(item) {
      if (!(await confirmAsk(this, 'صفحه «' + item.name + '» حذف شود؟'))) return
      axios.post('/api/admin/page/delete_page', { post_id: item.id }).then((res) => {
        apiToast(this, res)
        if (res.data && !res.data.error) this.$refs.table.removeRow(item.id)
      }).catch((e) => console.log(e))
    },
  },
}
</script>
